/* =========================================================================
   OS-ebook.js — E-bog landingpage: modal, lead-formular, download, FAQ,
   sticky mobil-CTA. Ingen afhaengigheder. Sikker at loade flere gange.
   ========================================================================= */
(function () {
  'use strict';

  // Filen kan blive indlaest af flere sektioner paa samme side.
  if (window.__osEbookLoaded) { return; }
  window.__osEbookLoaded = true;

  var MODAL_SELECTOR = '[data-os-eb-modal]';
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select,textarea,[tabindex]:not([tabindex="-1"])';

  /* ---------------------------------------------------------------------
     Hjaelpere
     --------------------------------------------------------------------- */
  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function isEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(value).trim());
  }

  // Bevidst lempelig: accepterer minshop.dk, www.minshop.dk og fulde URLer.
  function isUrlish(value) {
    var v = String(value).trim().replace(/^https?:\/\//i, '');
    return /^[^\s\/]+\.[a-z]{2,}/i.test(v);
  }

  function trigger(name, detail) {
    var evt;
    try {
      evt = new CustomEvent(name, { detail: detail, bubbles: true });
    } catch (e) {
      evt = document.createEvent('CustomEvent');
      evt.initCustomEvent(name, true, false, detail);
    }
    document.dispatchEvent(evt);
  }

  // Venter paa at et globalt script (fx Metas fbq) bliver frigivet af
  // cookiebanneret og faerdigloader. Giver op efter timeout.
  function whenAvailable(get, run, timeoutMs) {
    var found = get();
    if (found) { run(found); return; }
    var waited = 0;
    var limit = timeoutMs || 10000;
    var iv = window.setInterval(function () {
      waited += 200;
      var v = get();
      if (v) { window.clearInterval(iv); run(v); }
      else if (waited >= limit) { window.clearInterval(iv); }
    }, 200);
  }

  function fileNameFrom(url) {
    try {
      var last = new URL(url, window.location.href).pathname.split('/').pop();
      if (last && last.indexOf('.') > -1) { return decodeURIComponent(last); }
    } catch (e) { /* ignore */ }
    return 'e-bog.pdf';
  }

  function clickLink(href, name, newTab) {
    var a = document.createElement('a');
    a.href = href;
    if (name) { a.download = name; }
    if (newTab) {
      a.target = '_blank';
      a.rel = 'noopener noreferrer';
    }
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    window.setTimeout(function () {
      if (a.parentNode) { a.parentNode.removeChild(a); }
    }, 100);
  }

  // Filen hentes som blob foerst. Ellers bliver den enten aabnet i stedet for
  // hentet (Shopifys CDN sender PDF inline), eller blokeret som popup, fordi
  // der ikke er nogen brugerhandling at haenge target=_blank op paa efter
  // sideskiftet. Blob-download rammes ikke af nogen af delene.
  function openFile(url) {
    if (!url) { return false; }
    var name = fileNameFrom(url);

    if (window.fetch && window.URL && window.URL.createObjectURL) {
      fetch(url, { mode: 'cors' })
        .then(function (res) {
          if (!res.ok) { throw new Error('status ' + res.status); }
          return res.blob();
        })
        .then(function (blob) {
          var objectUrl = window.URL.createObjectURL(blob);
          clickLink(objectUrl, name, false);
          window.setTimeout(function () { window.URL.revokeObjectURL(objectUrl); }, 60000);
        })
        .catch(function () {
          clickLink(url, name, true);
        });
      return true;
    }

    clickLink(url, name, true);
    return true;
  }

  /* ---------------------------------------------------------------------
     Modal
     --------------------------------------------------------------------- */
  function Modal(root) {
    this.root = root;
    this.dialog = qs('[data-os-eb-dialog]', root);
    this.viewForm = qs('[data-os-eb-view="form"]', root);
    this.viewSuccess = qs('[data-os-eb-view="success"]', root);
    this.lastFocus = null;
    this.bind();
  }

  Modal.prototype.bind = function () {
    var self = this;

    qsa('[data-os-eb-close]', this.root).forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        self.close();
      });
    });

    this.root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.keyCode === 27) {
        e.preventDefault();
        self.close();
        return;
      }
      if (e.key === 'Tab' || e.keyCode === 9) { self.trapFocus(e); }
    });
  };

  Modal.prototype.trapFocus = function (e) {
    var items = qsa(FOCUSABLE, this.dialog).filter(function (el) {
      return el.offsetParent !== null || el === document.activeElement;
    });
    if (!items.length) { return; }
    var first = items[0];
    var last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  };

  Modal.prototype.open = function (openerEl) {
    this.lastFocus = openerEl || document.activeElement;
    this.root.classList.add('is-open');
    this.root.removeAttribute('aria-hidden');
    document.body.classList.add('os-eb-modal-open');

    var focusTarget = qs('[data-os-eb-autofocus]', this.root) || qs(FOCUSABLE, this.dialog);
    if (focusTarget) {
      window.setTimeout(function () { focusTarget.focus(); }, 60);
    }
    trigger('os-ebook:open', { modal: this.root });
  };

  Modal.prototype.close = function () {
    this.root.classList.remove('is-open');
    this.root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('os-eb-modal-open');
    if (this.lastFocus && typeof this.lastFocus.focus === 'function') {
      this.lastFocus.focus();
    }
    trigger('os-ebook:close', { modal: this.root });
  };

  Modal.prototype.showSuccess = function () {
    if (this.viewForm) { this.viewForm.hidden = true; }
    if (this.viewSuccess) { this.viewSuccess.hidden = false; }
  };

  Modal.prototype.showForm = function () {
    if (this.viewForm) { this.viewForm.hidden = false; }
    if (this.viewSuccess) { this.viewSuccess.hidden = true; }
  };

  /* ---------------------------------------------------------------------
     Formular
     --------------------------------------------------------------------- */
  function setFieldError(input, message) {
    var field = input.closest ? input.closest('.os-eb-field') : null;
    if (!field) { return; }
    var box = qs('.os-eb-field__error', field);
    if (message) {
      field.classList.add('has-error');
      input.setAttribute('aria-invalid', 'true');
      if (box) { box.textContent = message; }
    } else {
      field.classList.remove('has-error');
      input.removeAttribute('aria-invalid');
    }
  }

  function validate(form) {
    var ok = true;
    var firstBad = null;

    qsa('[data-os-eb-required]', form).forEach(function (input) {
      var value = String(input.value || '').trim();
      var msg = '';

      if (!value) {
        msg = input.getAttribute('data-os-eb-msg-empty') || 'Feltet skal udfyldes.';
      } else if (input.type === 'email' && !isEmail(value)) {
        msg = input.getAttribute('data-os-eb-msg-invalid') || 'Skriv en gyldig mailadresse.';
      } else if (input.type === 'tel' && value.replace(/[^0-9]/g, '').length < 8) {
        msg = input.getAttribute('data-os-eb-msg-invalid') || 'Skriv et gyldigt telefonnummer.';
      } else if (input.getAttribute('data-os-eb-field') === 'shop' && !isUrlish(value)) {
        msg = input.getAttribute('data-os-eb-msg-invalid') || 'Linket ser ikke rigtigt ud.';
      }

      setFieldError(input, msg);
      if (msg) {
        ok = false;
        if (!firstBad) { firstBad = input; }
      }
    });

    if (firstBad) { firstBad.focus(); }
    return ok;
  }

  function showFormMessage(form, message) {
    var box = qs('[data-os-eb-formerror]', form);
    if (!box) { return; }
    if (message) {
      box.hidden = false;
      box.textContent = message;
    } else {
      box.hidden = true;
      box.textContent = '';
    }
  }

  function afterSuccess(modal, form) {
    var cfg = modal ? modal.root : form;
    var mode = cfg.getAttribute('data-os-eb-after') || 'download';
    var fileUrl = cfg.getAttribute('data-os-eb-file') || '';
    var redirectUrl = cfg.getAttribute('data-os-eb-redirect') || '';
    var title = cfg.getAttribute('data-os-eb-title') || '';

    trigger('os-ebook:submitted', { ebook: title, file: fileUrl });

    // Shopify customer event, saa et Custom Pixel kan abonnere paa den
    // med analytics.subscribe('ebook_lead', ...) hvis der bliver brug for det.
    try {
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
        window.Shopify.analytics.publish('ebook_lead', {
          ebook: title,
          landingpage: document.title,
          url: window.location.pathname
        });
      }
    } catch (e) { /* ignore */ }

    // Meta-pixlen ligger paa siden, men frigives foerst af cookiebanneret og
    // loader asynkront. Paa kvitteringssiden er den derfor sjaeldent klar
    // endnu, saa der ventes paa den. Giver den besoegende ikke
    // markedsfoerings-samtykke, dukker fbq aldrig op, og saa fyres der
    // med vilje ingenting.
    whenAvailable(function () { return window.fbq; }, function (fbq) {
      try { fbq('track', 'Lead', { content_name: title }); } catch (e) { /* ignore */ }
    });

    whenAvailable(function () { return window.gtag; }, function (gtag) {
      try { gtag('event', 'generate_lead', { item_name: title }); } catch (e) { /* ignore */ }
    });

    try {
      if (window.dataLayer && window.dataLayer.push) {
        window.dataLayer.push({ event: 'ebook_download', ebook_title: title });
      }
    } catch (e) { /* ignore */ }

    if (cfg.getAttribute('data-os-eb-klaviyo') === 'true' && window.klaviyo) {
      try {
        var payload = { $email: '', $first_name: '', $phone_number: '' };
        var email = qs('[data-os-eb-field="email"]', form);
        var name = qs('[data-os-eb-field="name"]', form);
        var phone = qs('[data-os-eb-field="phone"]', form);
        if (email) { payload.$email = email.value; }
        if (name) { payload.$first_name = name.value; }
        if (phone) { payload.$phone_number = phone.value; }
        window.klaviyo.identify(payload);
        window.klaviyo.push(['track', 'Downloaded ebook', { Ebook: title }]);
      } catch (e) { /* ignore */ }
    }

    if (mode === 'redirect' && redirectUrl) {
      window.location.href = redirectUrl;
      return;
    }

    if (modal) { modal.showSuccess(); }
    openFile(fileUrl);
  }

  function bindForm(form, modal) {
    if (form.getAttribute('data-os-eb-bound') === 'true') { return; }
    form.setAttribute('data-os-eb-bound', 'true');

    qsa('[data-os-eb-required]', form).forEach(function (input) {
      input.addEventListener('input', function () { setFieldError(input, ''); });
      input.addEventListener('blur', function () {
        if (String(input.value || '').trim()) { validateSingle(input); }
      });
    });

    function validateSingle(input) {
      var value = String(input.value || '').trim();
      var msg = '';
      if (input.type === 'email' && value && !isEmail(value)) {
        msg = input.getAttribute('data-os-eb-msg-invalid') || 'Skriv en gyldig mailadresse.';
      }
      setFieldError(input, msg);
    }
  }

  /* ---------------------------------------------------------------------
     Indsendelse. Formularen sendes som en helt almindelig POST, fordi
     Shopifys bot-beskyttelse selv skal naa at haefte sit captcha-token paa.
     Kvittering + download sker naar siden kommer tilbage og sektionen
     saetter data-os-eb-state="success".
     Listeneren ligger paa document i capture-fasen, saa validering altid
     naar at koere foer Shopifys egen submit-handler.
     --------------------------------------------------------------------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM' || !form.querySelector) { return; }
    var root = form.querySelector('[data-os-eb-modal]');
    if (!root) { return; }
    var modal = root.osEbModal || (root.osEbModal = new Modal(root));

    showFormMessage(form, '');

    if (!validate(form)) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }

    // Honeypot: udfyldt = bot. Stop stille.
    var hp = qs('[data-os-eb-hp]', form);
    if (hp && String(hp.value || '').trim() !== '') {
      e.preventDefault();
      e.stopPropagation();
      modal.showSuccess();
      return;
    }

    // Goer shop-linket klikbart i mailen.
    var shop = qs('[data-os-eb-field="shop"]', form);
    if (shop) {
      var sv = String(shop.value || '').trim();
      if (sv && !/^https?:\/\//i.test(sv)) { shop.value = 'https://' + sv; }
      else if (sv) { shop.value = sv; }
    }

    // Bevidst uden disabled: Shopifys bot-beskyttelse afbryder submit og
    // sender formularen igen selv, og en deaktiveret knap kan spaende ben.
    var btn = qs('[data-os-eb-submit]', form);
    if (btn) {
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
      window.setTimeout(function () {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
      }, 12000);
    }
  }, true);

  /* ---------------------------------------------------------------------
     FAQ
     --------------------------------------------------------------------- */
  function initFaq(scope) {
    qsa('[data-os-eb-faq]', scope).forEach(function (list) {
      if (list.getAttribute('data-os-eb-bound') === 'true') { return; }
      list.setAttribute('data-os-eb-bound', 'true');
      var single = list.getAttribute('data-os-eb-faq-single') === 'true';

      qsa('.os-eb-faq__q', list).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var item = btn.parentNode;
          var isOpen = item.classList.contains('is-open');

          if (single) {
            qsa('.os-eb-faq__item', list).forEach(function (other) {
              if (other !== item) {
                other.classList.remove('is-open');
                var ob = qs('.os-eb-faq__q', other);
                if (ob) { ob.setAttribute('aria-expanded', 'false'); }
              }
            });
          }

          item.classList.toggle('is-open', !isOpen);
          btn.setAttribute('aria-expanded', String(!isOpen));
        });
      });
    });
  }

  /* ---------------------------------------------------------------------
     Sticky mobil-CTA
     --------------------------------------------------------------------- */
  function initSticky(scope) {
    var bar = qs('[data-os-eb-sticky]', scope) || qs('[data-os-eb-sticky]');
    if (!bar || bar.getAttribute('data-os-eb-bound') === 'true') { return; }
    bar.setAttribute('data-os-eb-bound', 'true');
    document.body.classList.add('os-eb-has-sticky');

    var anchor = qs('[data-os-eb-sticky-anchor]');

    function update() {
      var show;
      if (anchor) {
        show = anchor.getBoundingClientRect().bottom < 0;
      } else {
        show = window.pageYOffset > 420;
      }
      bar.classList.toggle('is-visible', show);
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  /* ---------------------------------------------------------------------
     Opstart
     --------------------------------------------------------------------- */
  function initModals(scope) {
    qsa(MODAL_SELECTOR, scope).forEach(function (root) {
      var modal = root.osEbModal;
      if (!modal) {
        modal = new Modal(root);
        root.osEbModal = modal;
      }

      // Formularen omslutter modalen, saa den findes opad — ikke indad.
      var form = (root.closest ? root.closest('form') : null) || qs('form', root);
      if (form) { bindForm(form, modal); }

      // Server-side kvittering efter almindelig POST (uden JS/fetch).
      if (root.getAttribute('data-os-eb-state') === 'success') {
        root.setAttribute('data-os-eb-state', 'done');
        modal.showSuccess();
        modal.open();
        if (form) { afterSuccess(modal, form); }
      } else if (root.getAttribute('data-os-eb-state') === 'error') {
        root.setAttribute('data-os-eb-state', 'done');
        modal.showForm();
        modal.open();
      }
    });
  }

  function currentModal(openerEl) {
    var id = openerEl && openerEl.getAttribute('data-os-eb-open');
    var root = null;
    if (id && id !== 'true') { root = document.getElementById(id); }
    if (!root) { root = qs(MODAL_SELECTOR); }
    if (!root) { return null; }
    if (!root.osEbModal) { root.osEbModal = new Modal(root); }
    return root.osEbModal;
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest ? e.target.closest('[data-os-eb-open]') : null;
    if (!opener) { return; }
    var modal = currentModal(opener);
    if (!modal) { return; } // ingen formular paa siden: lad linket virke normalt
    e.preventDefault();
    modal.showForm();
    modal.open(opener);
  });

  /* ---------------------------------------------------------------------
     Kilde-sporing: laegger annonce-parametre (utm, gclid, fbclid) og
     henvisende side ind i et skjult felt, saa de kommer med i mailen.
     --------------------------------------------------------------------- */
  function initSource(scope) {
    qsa('[data-os-eb-source]', scope).forEach(function (input) {
      var parts = [];
      var query = String(window.location.search || '').replace(/^[?]/, '');
      if (query && query.indexOf('contact_posted') === -1) { parts.push(query); }
      if (document.referrer) { parts.push('ref: ' + document.referrer); }
      input.value = parts.join(' | ').slice(0, 500);
    });
  }

  function boot(scope) {
    initModals(scope || document);
    initFaq(scope || document);
    initSticky(scope || document);
    initSource(scope || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  // Theme editor
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:unload', function () {
    document.body.classList.remove('os-eb-modal-open');
  });

  window.OSEbook = { open: function () { var m = currentModal(null); if (m) { m.showForm(); m.open(); } } };
})();
